import ViewSection from "../ViewSection"
import DataTable from "react-data-table-component";
import TableLoader from "../TableLoader";

import usePartnerStaffAssignedProjects from "../../hooks/usePartnerStaffAssignedProjects";
import { formatDateToSydneyTimeZone } from "../../utils/dateUtils";

const PartnerAdminStaffView = ({ user, onCloseClicked }) => {
  const { data: projectsData, isLoading: isLoadingProjects } = usePartnerStaffAssignedProjects({
    staffId: user._id,
    page: 1,
    perPage: 9999
  });

  const projects = projectsData?.projects || [];

  const columns = [
    {
      name: 'Name',
      selector: row => row.name,
      sortable: true
    },
    {
      name: 'Start date',
      selector: row => formatDateToSydneyTimeZone(row.startDate),
      sortable: true
    },
    {
      name: 'End date',
      selector: row => formatDateToSydneyTimeZone(row.endDate),
      sortable: true
    }
  ];

  return (
    <div className="bg-white rounded-lg border border-ase-blue w-full md:w-auto md:min-w-[700px]">
      <div className="flex items-center justify-between text-lg bg-ase-blue text-white font-bold rounded-t-md p-4">
        <p>{user.fullName}</p>

        <p
          onClick={onCloseClicked}
          className="font-bold cursor-pointer text-2xl"
        >
          X
        </p>
      </div>

      <div className="flex flex-col gap-2 p-4">
        <p><b className="inline-block min-w-[150px]">Full name:</b>{user.fullName}</p>
        <p><b className="inline-block min-w-[150px]">Email:</b>{user.email}</p>
        <p><b className="inline-block min-w-[150px]">Phone</b>{user.phoneNumber || 'Not added'}</p>
        <p><b className="inline-block min-w-[150px]">Phone</b>{user.dateOfBirth || 'Not added'}</p>
      </div>

      <ViewSection
        title="Allocations"
        content={(
          <DataTable
            columns={columns}
            data={projects}
            striped
            highlightOnHover
            pointerOnHover
            progressPending={isLoadingProjects}
            progressComponent={<TableLoader />}
            pagination
            paginationRowsPerPageOptions={[10, 20, 50]}
            paginationPerPage={5}
          />
        )}
      />
    </div>
  )
}

export default PartnerAdminStaffView;
